<template>
  <span v-if="type" v-b-tooltip.hover :title="title">
    <span v-if="sms_count > 0">
      <i class="fa fa-fw fa-sms text-muted"></i>
      {{ knownAtSendBecauseFilter ? '?' : numeral(sms_count).format('0,000') }}
    </span>
    <span v-if="sms_count > 0 && email_count > 0">&nbsp;</span>
    <span v-if="email_count > 0">
      <i class="fa fa-fw fa-envelope text-muted"></i>
      {{ knownAtSendBecauseFilter ? '?' : numeral(email_count).format('0,000') }}
    </span>
  </span>
</template>

<script>
  export default {
    props: {
      organization: Object,
      type: String,
      sms_count: Number,
      email_count: Number,
      knownAtSendBecauseFilter: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        numeral: numeral,
      }
    },
    computed: {
      title() {
        return this.knownAtSendBecauseFilter ?
          trans('known_at_send_because_filter') :
          trans(this.type+'_count_estimate').replace(':sms', this.sms_count).replace(':email', this.email_count)
      },
    },
    mounted() {
      window.countComponent = this
    },
  }
</script>